import { Layout } from "../UI/Layout/Layout.tsx";
import { Card } from "../UI/Card.tsx";
import { ScreenTitleBlock } from "../UI/Layout/ScreenTitleBlock.tsx";
import { BreadCrumbsWrapper } from "../UI/Layout/BreadCrumbsWrapper.tsx";
import { BreadCrumbsItem } from "../UI/Layout/BreadCrumbsItem.tsx";
import { useNavigate } from "react-router-dom";
import { ErrorMessagePopup } from "../UI/MessagePopup/ErrorMessagePopup.tsx";
import { useMessagePopupController } from "../UI/MessagePopup/useMessagePopupController.ts";
import { ApolloError } from "@apollo/client";
import { CreateBulkClassRoomForm } from "./CreateBulkClassRoomForm.tsx";
import { useCreateBulkClassRoomCreationIntent } from "./useCreateBulkClassRoomCreationIntent.ts";

export const CreateBulkClassRoomScreenPath = "/bulk-classrooms/new";

export function CreateBulkClassRoomScreen() {
  const { createBulkClassRoomCreationIntent } =
    useCreateBulkClassRoomCreationIntent();
  const navigate = useNavigate();
  const { show, showPopup, description, title } = useMessagePopupController(
    4 * 1000,
  );

  return (
    <>
      <ErrorMessagePopup title={title} description={description} show={show} />
      <Layout>
        <Card>
          <ScreenTitleBlock
            title={"Create Bulk ClassRoom"}
            breadCrumbs={
              <BreadCrumbsWrapper>
                <BreadCrumbsItem title={"Create Bulk ClassRoom"} />
              </BreadCrumbsWrapper>
            }
          />
        </Card>
        <div className={"mt-4"}>
          <Card>
            <CreateBulkClassRoomForm
              onCreate={async (data) => {
                try {
                  const intent = await createBulkClassRoomCreationIntent({
                    teacherId: data.teacherId,
                    studentId: data.studentId,
                    startDate: data.startDate.toISOString(),
                    numberOfWeeks: data.numberOfWeeks,
                    maxClassRoomNumber: data.maxClassRoomNumber,
                    user1on1ClassroomPlanToBeRedeemedId: data.isGiftedPlan
                      ? undefined
                      : data.user1on1ClassroomPlanToBeRedeemedId,
                    weekSlots: data.weekSlots,
                  });

                  navigate(`/bulk-classrooms/intent/${intent.id}`);
                } catch (e) {
                  const error = e as ApolloError;
                  showPopup(
                    "Error",
                    `An error occurred during bulk classroom creation: ${error.message ?? "Unknown error"}`,
                  );
                }
              }}
            />
          </Card>
        </div>
      </Layout>
    </>
  );
}
